import Vue from 'vue'
import router from '@/router/index'
import store from '@/store/index'
import '@/utils/utils'
import '@/utils/rem'
import '@/vant'
import '@/echarts'
import '@/assets/style/reset.less'
import App from '@/App.vue'

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
